define('controller/disclosure/disclosure.send.adhoc.controller',['require','exports','module','fukit','view/disclosure/disclosure.send.adhoc.view','model/ad.hoc.disclosee.model','model/disclosure.detail.model','backbone.radio','underscore','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController            = require('fukit').BaseController,
        DisclosureSendAdHocView = require('view/disclosure/disclosure.send.adhoc.view'),
        AdHocDiscloseeModel     = require('model/ad.hoc.disclosee.model'),
        DisclosureDetailModel   = require('model/disclosure.detail.model'),
        Radio                   = require('backbone.radio'),
        _                       = require('underscore'),
        ROLES                   = require('fukit').Roles;

  var  coiModel;
  var  productNewCoiUiValue = false;
  const enabledProductCollection =   Radio.request(
      'AppKit.resourceService',
      'resource',
      'enabledProductCollection'
  );

  if (!_.isUndefined(enabledProductCollection)) {
    coiModel = enabledProductCollection.findWhere({name: 'COI', active: true});
    const dataModel = coiModel.collection.models;
    const filteredDataArray = dataModel.filter(function (item) {
      return item.attributes.name === "COI" && item.attributes.active === true;
    });
    productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
  }

  if(productNewCoiUiValue){
    localStorage.setItem("productNewCoiUiValue", productNewCoiUiValue.toString());
    location.assign(location.origin + '/coi-react/disclosure/send');
  }

  var DisclosureSendAdHocController = BaseController.extend({
    radioRequests: {
      'controllers DisclosureSendAdHocController': '@constructor',
    },

    pageView: DisclosureSendAdHocView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES,
      },
    },

    resources: {
      adHocDiscloseeModel: {
        model: AdHocDiscloseeModel,
        fetchOnStart: true,
      },
      adHocMemberFinderSelectedCollection: {
        collection: AdHocDiscloseeModel.Collection.extend({
          url: '/api/v2/coi/adhoc/send',
          model: AdHocDiscloseeModel,
          save: function() {
            this.sync('create', this, this.options);
          },
        }),
      },
      adHocDiscloseeCollection: {
        fetchOnStart: true,
        collection: AdHocDiscloseeModel.Collection.extend({
          sort: {
            field: 'firstName',
            direction: 'descending',
          },
        }),
      },
      // Utility resource
      uiState: {
        model: Backbone.Model.extend({
          defaults: {
            disableLinkButton: true,
            userLinked: false,
            userPending: false,
            sidebarLoading: false,
            emailActionSuccess: false,
            emailActionNotify: false,
          },
        }),
      },
    },

    onStart: function() {
      if (this.state.get('disclosureStatus')) {
        this.getResource('disclosureCollection').filters.add({
          field: 'status',
          value: this.state.get('disclosureStatus'),
        });
      }
    },
  });

  module.exports = DisclosureSendAdHocController;
});

